<template>
  <dnevnik-tabela :podatki="podatki" :nalaganje-tabele="nalaganjeTabele">
    <el-table-column slot="extra-columns-desktop" prop="website" sortable label="Spletno mesto">
      <template slot-scope="scope">{{ scope.row.website || '/' }}</template>
    </el-table-column>
    <template slot="extra-fields-mobile" slot-scope="{ row }">
      <p><span><b>Spletno mesto: </b></span>{{ row.website || '/' }}</p>
    </template>
  </dnevnik-tabela>
</template>

<script>
import Vue from 'vue'
import {Table, TableColumn} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
import DnevnikTabela from './DnevnikTabela.vue'
import LogsService from '../../../../../assets/js/Logs/LogsService.js'
Vue.use(Table)
Vue.use(TableColumn)
export default {
  name: 'ZgodovinaDostopov',
  mixins: [FormatDatuma],
  components: {DnevnikTabela},
  data () {
    return {
      logsService: null,
      nalaganjeTabele: false,
      podatki: []
    }
  },
  mounted () {
    this.logsService = new LogsService(new ClientAgent())
    this.fetchLoginHistory()
  },
  methods: {
    async fetchLoginHistory () {
      this.nalaganjeTabele = true
      try {
        const podatki = await this.logsService.fetchLoginHistory()
        this.setUserData(podatki)
      } catch (e) {
        this.errUserData(e)
      }
    },
    setUserData (podatki) {
      this.podatki = podatki.data.map(item => {
        Vue.set(item, 'formatDatuma', this.PoenotenIzgledDatuma(item.datum.date))
        return item
      })
      this.nalaganjeTabele = false
    },
    errUserData (e) {
      this.ShowWarningMessage({message: e.message})
      this.nalaganjeTabele = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Varnost/ZgodovinaDostopov.vue